// extracted by mini-css-extract-plugin
export default {"title":"_1chHPRy0GnUsQpfhfhZSVz"};